"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const objectUtils_1 = __importDefault(require("@utils/objectUtils"));
const react_1 = __importDefault(require("react"));
require("./style.scss");
const Modal = ({ children, isFixedHeight, handleCancel, className }) => {
    const [mouseDownElement, setMouseDownElement] = react_1.default.useState(null);
    // const notFound = -1;
    const handleClickBackDrop = () => {
        setMouseDownElement(null);
        // if (!ObjectUtils.isExist(mouseDownElement)) handleCancel ? handleCancel() : '';
        if (!objectUtils_1.default.isExist(mouseDownElement))
            handleCancel();
    };
    const handleClickInsideModal = (event) => event.stopPropagation();
    const handleMouseDown = (event) => {
        setMouseDownElement(event.target);
    };
    /**
     * 判斷滑鼠放開時的位置是否在modal__wrapper內
     */
    const handleMouseUp = () => {
        var _a;
        const modalElement = document.querySelector('.modal__wrapper');
        if (!objectUtils_1.default.isExist(mouseDownElement))
            if (!(modalElement === null || modalElement === void 0 ? void 0 : modalElement.contains(mouseDownElement)) && ((_a = mouseDownElement === null || mouseDownElement === void 0 ? void 0 : mouseDownElement.className) === null || _a === void 0 ? void 0 : _a.includes('modal__backdrop'))) {
                // handleCancel ? handleCancel() : '';
                handleCancel();
            }
        setMouseDownElement(null);
    };
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "modal__backdrop", onClick: handleClickBackDrop }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: `modal__wrapper ${isFixedHeight && 'fixedHeight'} ${className}`, onClick: handleClickInsideModal, onMouseUp: handleMouseUp, onMouseDown: handleMouseDown }, { children: children })) })));
};
exports.default = Modal;
